export default __webpack_public_path__ + "static/media/art-0-andy.b1c4a06c.jpeg";